<template>
  <div class="container">
    <div class="instructions">
      {{ instructions }}
    </div>
    <div class="textarea" v-show="isSecondStep">
      <textarea placeholder="Your description goes here" ref="textarea" v-model="text" rows="8" />
      <div v-if="showErrorMessage" class="error">* Description is required</div>
    </div>
    <div class="actions">
      <button class="bigmi-cancel-button" @click="emitCancel">Cancel</button>
      <button class="bigmi-continue-button" @click="handleSubmit">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  EVENT_NAME_SUBMIT,
  EVENT_NAME_CANCEL,
  IDEA_COACH_TYPE,
  GET_IDEA_COACH_STATE,
  A_UPDATE_IDEA_COACH_STATE,
} from "../../services/constants";
export default {
  name: "IdeaCoachForm",
  props: {
    type: {
      type: String,
      default: "",
    },
    instructions: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showErrorMessage: false,
    };
  },
  computed: {
    ...mapGetters([GET_IDEA_COACH_STATE]),
    text: {
      get() {
        return this.ideaCoachState.description;
      },
      set(description) {
        this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { description });
      },
    },
    currentStep() {
      return this.ideaCoachState.formStep;
    },
    isFirstStep() {
      return this.currentStep === 1;
    },
    isSecondStep() {
      return this.currentStep === 2;
    },
    buttonText() {
      return this.isFirstStep ? "Continue" : "Submit";
    },
    ideaCoachState() {
      return this[GET_IDEA_COACH_STATE];
    },
  },
  methods: {
    handleSubmit() {
      if (this.isFirstStep && this.type === IDEA_COACH_TYPE.question) {
        this.goToSecondStep();
      } else {
        if (this.type === IDEA_COACH_TYPE.question && !this.text) {
          this.showErrorMessage = true;
          return;
        }
        this.emitSubmit();
      }
    },
    goToSecondStep() {
      this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { formStep: 2 });
    },
    emitSubmit() {
      this.$emit(EVENT_NAME_SUBMIT, this.text);
    },
    emitCancel() {
      this.$emit(EVENT_NAME_CANCEL);
    },
  },
  watch: {
    isSecondStep(newVal) {
      if (newVal) {
        this.$refs.textarea.focus();
      }
    },
  },
  mounted() {
    if (this.ideaCoachState.description) {
      this.goToSecondStep();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main";
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.container > * {
  margin: 1rem;
}

.instructions {
  text-align: left;
  line-height: 1.5;
  letter-spacing: 0.12ch;
}

.textarea {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 2rem;
  textarea {
    width: 100%;
  }
}

.actions {
  margin-top: auto;
  display: flex;
  justify-content: center;
}

.actions > * {
  margin: 2rem;
}

.error {
  padding: 1em 0;
  color: $red-2;
  font-size: 12px;
}
</style>
